/* eslint-env browser */
const getAssocsFromSessionStorage = () => (!sessionStorage.getItem('gym-assocs') ? [] : sessionStorage.getItem('gym-assocs').split(',').map((x) => parseInt(x, 10)));

export default getAssocsFromSessionStorage;
